import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IndentListService } from '../indent-list.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-view-indent-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-indent-list.component.html',
  styleUrls: ['./view-indent-list.component.scss'],
})
export class ViewIndentListComponent implements OnInit {
  indent: any;
  isPosted: boolean = false;
  isStatusChanged: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private indentService: IndentListService
  ) {}

  ngOnInit(): void {
    // ✅ Get "id" from route (suggestion.id, not indentId)
    const suggestionId = this.route.snapshot.paramMap.get('id');
    if (suggestionId) {
      this.loadIndentDetails(suggestionId);
    }
  }

  // ✅ Fetch and map to UI-friendly structure
  loadIndentDetails(id: string) {
    this.indentService.getIndentById(id).subscribe({
      next: (data: any) => {
        this.indent = {
          id: data?.id || null,
          indentNumber: data?.indentNumber || '-',
          locationName: data?.store?.name || '-',
          date: data?.suggestionDate,
          status: data?.status,
          //   createdBy: data?.indent?.createdBy || 'System',
          //   approvedBy: data?.indent?.approvedBy || null,

          // ✅ Store details
          store: {
            name: data?.store?.name || '-',
            code: data?.store?.storeCode || '-',
            city: data?.store?.city || '-',
            address: data?.store?.address || '-',
          },

          // ✅ Department details
          department: {
            name: data?.department?.name || '-',
            code: data?.department?.departmentCode || '-',
          },

          items: (data?.items || []).map((item: any) => ({
            itemName: item?.productVariant?.product?.name || '-',
            sku: item?.productVariant?.product?.sku || '-',
            isActive: item?.productVariant?.product?.isActive || '-',
            indentQuantity: item?.quantity || 0,
          })),
        };

        console.log('Mapped indent details:', this.indent);
      },
      error: (err: any) => {
        console.error('Failed to fetch indent details', err);
      },
    });
  }

  goBack() {
    this.router.navigate(['/indent-list']);
  }
  toggleStatus(posted: boolean): void {
    this.isPosted = posted;
  }

  saveStatus(): void {
    // Check if the toggle is in the POSTED state before saving
    if (this.isPosted) {
      console.log('this.indent.id', this.indent);
      const id = this.indent.id;
      const payload = { status: 'POSTED' };

      // Use the service method to call the API
      this.indentService.updateIndentStatus(id, payload).subscribe(
        () => {
          console.log('Status updated to POSTED successfully.');
          // Update the local indent object to reflect the change
          this.indent.status = 'POSTED';
          // Optionally, add a success notification here
        },
        (error) => {
          console.error('Error updating status:', error);
          // Revert the toggle state if the API call fails
          this.isPosted = false;
          // Optionally, add an error notification here
        }
      );
    }
  }
}
